<sc-auth-page-wrapper mainTitle="Genial!" [subtitle]="subtitle">
  <div auth-page-wrapper-content class="text-center">
    <img [src]="successImage" alt="Exito" class="success-image">
  </div>
  <sc-auth-legal-footer auth-page-wrapper-footer></sc-auth-legal-footer>
</sc-auth-page-wrapper>
